import { axiosAuthMiddleware } from 'app/core/auth/AxiosAuthMiddleware'
import axios from 'axios'

axios.defaults.headers.common = { 'Content-Type': 'application/json' }
axios.defaults.headers.put = { 'Content-Type': 'application/json' }
axios.interceptors.request.use(axiosAuthMiddleware)
